webpackJsonp([1],{

/***/ "FF7R":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "M93x":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_App_vue__ = __webpack_require__("xJD8");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1abe62c4_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_App_vue__ = __webpack_require__("Uzws");
function injectStyle (ssrContext) {
  __webpack_require__("fD0S")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_App_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1abe62c4_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_App_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "NHnr":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__("/5sW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_clipboard2__ = __webpack_require__("wvfG");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_clipboard2___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_vue_clipboard2__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_sweetalert2__ = __webpack_require__("oYt9");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__App__ = __webpack_require__("M93x");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__router__ = __webpack_require__("YaEn");
// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.






__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].config.productionTip = false;
__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_1_vue_clipboard2___default.a);
__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_2_vue_sweetalert2__["a" /* default */]);
/* eslint-disable no-new */
new __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */]({
  el: '#app',
  router: __WEBPACK_IMPORTED_MODULE_4__router__["a" /* default */],
  render: function render(h) {
    return h(__WEBPACK_IMPORTED_MODULE_3__App__["a" /* default */]);
  }
});

/***/ }),

/***/ "SscL":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"packlist"}},[_c('nav',{staticClass:"navbar navbar-inverse navbar-fixed-top"},[_c('div',{staticClass:"container-fluid"},[_vm._m(0),_vm._v(" "),_c('div',{staticClass:"collapse navbar-collapse",attrs:{"id":"responsive"}},[_vm._m(1),_vm._v(" "),_c('form',{staticClass:"navbar-form navbar-right",attrs:{"id":"search-form","role":"search"}},[_c('div',{staticClass:"form-group",attrs:{"for":"packlist-filter"}},[_c('input',{directives:[{name:"model",rawName:"v-model.trim",value:(_vm.currentFilter),expression:"currentFilter",modifiers:{"trim":true}}],staticClass:"form-control packlist-filter",attrs:{"type":"search","id":"packlist-filter","placeholder":"Filtered Search"},domProps:{"value":(_vm.currentFilter)},on:{"input":function($event){if($event.target.composing){ return; }_vm.currentFilter=$event.target.value.trim()},"blur":function($event){_vm.$forceUpdate()}}})])])])])]),_vm._v(" "),_c('div',{staticClass:"container",attrs:{"id":"main"}},[_c('div',{attrs:{"id":"content"}},[_c('img',{staticClass:"header-img center-block",attrs:{"src":"https://sumire.moe/wp-content/uploads/2017/10/nonoko-xdcc.png"}}),_vm._v(" "),_c('div',{staticClass:"panel panel-default"},[_vm._m(2),_vm._v(" "),_c('div',{staticClass:"table-responsive"},[_c('table',{staticClass:"table table-striped table-hover table-condensed",attrs:{"id":"packlist-data"}},[_c('thead',[_c('tr',[_c('th',{staticClass:"text-center",attrs:{"id":"pack-number"},on:{"click":function($event){_vm.sortKey = 'id'}}},[_vm._v("Pack #\n                  "),(_vm.sortKey !== 'id')?_c('span',{staticClass:"sort-btn fa fa-sort",attrs:{"id":"sort-default","aria-hidden":"true"}}):_vm._e(),_vm._v(" "),(_vm.sortKey === 'id' && _vm.direction == 1)?_c('span',{staticClass:"sort-btn fa fa-sort-numeric-asc",attrs:{"id":"sort-asc","aria-hidden":"true"}}):_vm._e(),_vm._v(" "),(_vm.sortKey === 'id' && _vm.direction == -1)?_c('span',{staticClass:"sort-btn fa fa-sort-numeric-desc",attrs:{"id":"sort-desc","aria-hidden":"true"}}):_vm._e()]),_vm._v(" "),_c('th',{staticClass:"text-center",attrs:{"id":"fetches"},on:{"click":function($event){_vm.sortKey = 'fetches'}}},[_c('span',{staticClass:"fa fa-download",attrs:{"aria-hidden":"true"}}),_vm._v(" "),(_vm.sortKey !== 'fetches')?_c('span',{staticClass:"sort-btn fa fa-sort",attrs:{"id":"sort-default","aria-hidden":"true"}}):_vm._e(),_vm._v(" "),(_vm.sortKey === 'fetches' && _vm.direction == 1)?_c('span',{staticClass:"sort-btn fa fa-sort-numeric-asc",attrs:{"id":"sort-asc","aria-hidden":"true"}}):_vm._e(),_vm._v(" "),(_vm.sortKey === 'fetches' && _vm.direction == -1)?_c('span',{staticClass:"sort-btn fa fa-sort-numeric-desc",attrs:{"id":"sort-desc","aria-hidden":"true"}}):_vm._e()]),_vm._v(" "),_c('th',{staticClass:"text-center",attrs:{"id":"file-size"},on:{"click":function($event){_vm.sortKey = 'size'}}},[_c('span',{staticClass:"fa fa-hdd-o",attrs:{"aria-hidden":"true"}}),_vm._v(" "),(_vm.sortKey !== 'size')?_c('span',{staticClass:"sort-btn fa fa-sort",attrs:{"id":"sort-default","aria-hidden":"true"}}):_vm._e(),_vm._v(" "),(_vm.sortKey === 'size' && _vm.direction == 1)?_c('span',{staticClass:"sort-btn fa fa-sort-numeric-asc",attrs:{"id":"sort-asc","aria-hidden":"true"}}):_vm._e(),_vm._v(" "),(_vm.sortKey === 'size' && _vm.direction == -1)?_c('span',{staticClass:"sort-btn fa fa-sort-numeric-desc",attrs:{"id":"sort-desc","aria-hidden":"true"}}):_vm._e()]),_vm._v(" "),_c('th',{staticClass:"text-left",attrs:{"id":"file-name"},on:{"click":function($event){_vm.sortKey = 'title'}}},[_c('span',{staticClass:"fa fa-file",attrs:{"aria-hidden":"true"}}),_vm._v(" "),(_vm.sortKey !== 'title')?_c('span',{staticClass:"sort-btn fa fa-sort",attrs:{"id":"sort-default","aria-hidden":"true"}}):_vm._e(),_vm._v(" "),(_vm.sortKey === 'title' && _vm.direction == 1)?_c('span',{staticClass:"sort-btn fa fa-sort-alpha-asc",attrs:{"id":"sort-asc","aria-hidden":"true"}}):_vm._e(),_vm._v(" "),(_vm.sortKey === 'title' && _vm.direction == -1)?_c('span',{staticClass:"sort-btn fa fa-sort-alpha-desc",attrs:{"id":"sort-desc","aria-hidden":"true"}}):_vm._e()]),_vm._v(" "),_vm._m(3)])]),_vm._v(" "),_c('tbody',_vm._l((_vm.packlist),function(pack){return _c('tr',{staticClass:"fade-animation"},[_c('td',{staticClass:"text-center"},[_vm._v(_vm._s(pack.id))]),_vm._v(" "),_c('td',{staticClass:"text-center"},[_vm._v(_vm._s(pack.fetches))]),_vm._v(" "),_c('td',{staticClass:"text-center"},[_vm._v(_vm._s(pack.size_text))]),_vm._v(" "),_c('td',{staticClass:"text-left"},[_vm._v(_vm._s(pack.title))]),_vm._v(" "),_c('td',{staticClass:"text-center"},[_c('button',{directives:[{name:"clipboard",rawName:"v-clipboard:copy",value:(_vm.getXdccCommand(pack.id)),expression:"getXdccCommand(pack.id)",arg:"copy"},{name:"clipboard",rawName:"v-clipboard:success",value:(_vm.onCopy),expression:"onCopy",arg:"success"},{name:"clipboard",rawName:"v-clipboard:error",value:(_vm.onError),expression:"onError",arg:"error"}],staticClass:"btn btn-primary",attrs:{"type":"button"}},[_vm._v("Copy Query\n                  ")])])])}))])])])])]),_vm._v(" "),_c('footer',{staticClass:"footer"},[_c('p',{staticClass:"text-center"},[_vm._v(_vm._s(_vm.bandwidth))]),_vm._v(" "),_c('p',{staticClass:"text-center"},[_vm._v(_vm._s(_vm.stats))]),_vm._v(" "),_vm._m(4)])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"navbar-header"},[_c('button',{staticClass:"navbar-toggle collapsed",attrs:{"type":"button","data-toggle":"collapse","data-target":"#responsive","aria-expanded":"false"}},[_c('span',{staticClass:"sr-only"},[_vm._v("Mobile Menu")]),_vm._v(" "),_c('span',{staticClass:"icon-bar"}),_vm._v(" "),_c('span',{staticClass:"icon-bar"}),_vm._v(" "),_c('span',{staticClass:"icon-bar"})]),_vm._v(" "),_c('a',{staticClass:"navbar-brand fade-animation",attrs:{"href":"https://xdcc.sumire.moe/"}},[_vm._v("XDCC Packlist")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ul',{staticClass:"nav navbar-nav"},[_c('li',[_c('a',{staticClass:"fade-animation",attrs:{"href":"https://sumire.moe"}},[_vm._v("Home")])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"panel-heading text-center"},[_c('h3',{staticClass:"xdcc-header"},[_vm._v("Sumire|Nonoko XDCC Packlist")]),_vm._v(" "),_c('p',[_c('a',{staticClass:"xdcc-link fade-animation",attrs:{"href":"irc://irc.rizon.net/Sumire"}},[_vm._v("#Sumire@irc.rizon.net")])]),_vm._v(" "),_c('p',{staticClass:"text-center"},[_vm._v("Please use the "),_c('strong',[_vm._v("Copy Query")]),_vm._v(" button to copy the XDCC command to your clipboard.")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('th',{staticClass:"text-center",attrs:{"id":"click-to-copy"}},[_c('span',{staticClass:"fa fa-files-o",attrs:{"aria-hidden":"true"}})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',{staticClass:"text-center"},[_vm._v("Developed by: "),_c('a',{staticClass:"xdcc-link fade-animation",attrs:{"href":"https://sumire.moe/staff/#Ayanami"}},[_vm._v("Ayanami")]),_vm._v(" & "),_c('a',{staticClass:"xdcc-link fade-animation",attrs:{"href":"https://sumire.moe/staff/#LastReaction"}},[_vm._v("LastReaction")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "UdIB":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "Uzws":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"app"}},[_c('router-view')],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "V0CM":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Packlist_vue__ = __webpack_require__("sFod");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_eae2a766_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_Packlist_vue__ = __webpack_require__("SscL");
function injectStyle (ssrContext) {
  __webpack_require__("FF7R")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Packlist_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_eae2a766_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_Packlist_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "YaEn":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__("/5sW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_router__ = __webpack_require__("/ocq");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_Packlist__ = __webpack_require__("V0CM");




__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]);

/* harmony default export */ __webpack_exports__["a"] = (new __WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]({
  routes: [{
    path: '/',
    name: 'Packlist',
    component: __WEBPACK_IMPORTED_MODULE_2__components_Packlist__["a" /* default */],
    props: { src: 'parse-packlist.pl' }
  }]
}));

/***/ }),

/***/ "fD0S":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "sFod":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

var HTTP_OK = 200;
var shared = [];

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'packlist',
  props: ['src'],
  data: function data() {
    return {
      currentFilter: '',
      direction: 1,
      currentSortKey: 'id',
      shared: shared,
      dataLoaded: false
    };
  },

  computed: {
    packs: function packs() {
      var _this = this;

      if (!this.dataLoaded) return [];
      if (!this._packs) {
        this._packs = this.shared.filter(function (p) {
          return p.src === _this.src;
        })[0].packs;
      }
      return this._packs;
    },
    packlist: function packlist() {
      return this.sort(this.filter(this.packs));
    },

    sortKey: {
      get: function get() {
        return this.currentSortKey;
      },
      set: function set(key) {
        if (this.currentSortKey === key) this.direction *= -1;else this.direction = 1;
        this.currentSortKey = key;
      }
    },
    bandwidth: function bandwidth() {
      var _this2 = this;

      if (!this.dataLoaded) return null;
      if (!this._bandwidth) {
        this._bandwidth = this.shared.filter(function (p) {
          return p.src === _this2.src;
        })[0].bandwidth;
      }
      return 'Bandwidth: current: ' + this._bandwidth.current + ' record: ' + this._bandwidth.record;
    },
    stats: function stats() {
      var _this3 = this;

      if (!this.dataLoaded) return null;
      if (!this._stats) {
        this._stats = this.shared.filter(function (p) {
          return p.src === _this3.src;
        })[0].stats;
      }
      return 'Total offered: ' + this._stats.offered + ' Total transferred: ' + this._stats.transferred;
    }
  },
  methods: {
    filter: function filter(data) {
      var _this4 = this;

      if (!this.currentFilter || !data) return data;
      return data.filter(function (x) {
        return x.title.toLowerCase().indexOf(_this4.currentFilter.toLowerCase()) !== -1;
      });
    },
    sort: function sort(data) {
      var _this5 = this;

      if (!data) return data;
      return data.sort(function (a, b) {
        if (_this5.sortKey === 'title') {
          return _this5.direction * a[_this5.sortKey].localeCompare(b[_this5.sortKey], ['ja-JP', 'en'], { numeric: true });
        }
        return _this5.direction * (a[_this5.sortKey] - b[_this5.sortKey]);
      });
    },
    getXdccCommand: function getXdccCommand(packId) {
      return '/msg Sumire|Nonoko XDCC SEND ' + packId;
    },
    onCopy: function onCopy(e) {
      this.$swal({
        title: 'Naisu!',
        html: '"' + e.text + '"<br/>has been copied to the clipboard.',
        imageUrl: 'https://sumire.moe/wp-content/uploads/2017/05/ryuu-no-haisha-about.jpg',
        imageWidth: 400,
        imageHeight: 250,
        imageAlt: 'Nonoko is so proud of you!',
        timer: 5000
      });
    },
    onError: function onError(e) {
      this.$swal({
        title: 'Yabai!',
        html: '"There seems to be an error.<br/>Try copying and pasting the text below:<br/>' + e.text,
        imageUrl: 'https://sumire.moe/wp-content/uploads/2017/10/nonoko-xdcc-error.jpg',
        imageWidth: 400,
        imageHeight: 250,
        imageAlt: 'Holy shit what is happening, help me!'
      });
    }
  },
  created: function created() {
    var _this6 = this;

    if (shared[this.src]) return;
    var xhr = new XMLHttpRequest();
    xhr.addEventListener('load', function () {
      if (xhr.status === HTTP_OK) {
        var list = JSON.parse(xhr.responseText);
        list.src = _this6.src;
        _this6.shared.push(list);
        _this6.dataLoaded = true;
      } else {
        // FIXME: display error somewhere
        console.error('Error loading packlist: ' + xhr.statusText);
      }
    });
    xhr.open('GET', this.src);
    xhr.send();
  }
});

/***/ }),

/***/ "xJD8":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'app'
});

/***/ })

},["NHnr"]);


// WEBPACK FOOTER //
// static/js/app.3463e086f5e13aff27a9.js